import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const CloseWindow = styled.button`
  position: fixed;
  top: 15px;
  right: 10px;
  font-family: Helvetica;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 11;
  @media (min-width: ${breakpoints.tablet}) {
    top: 30px;
    right: 30px;
  }
`;

export default CloseWindow;



// WEBPACK FOOTER //
// ./src/styled-components/CloseWindow.js